// Tracks whether the browser thinks it has a connection.
//
// navigator.onLine is only a hint — it reports the network interface,
// not whether Firestore can actually reach anything. It's still the
// right signal here: it flips instantly when a phone loses signal,
// and the alternative (waiting for a write to time out) tells the
// mechanic far too late to be useful.
import { useEffect, useState } from 'react';

export function useOnline() {
  const [online, setOnline] = useState(
    () => (typeof navigator === 'undefined' ? true : navigator.onLine)
  );

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  return online;
}
